import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay} from 'swiper/modules';
import React from 'react';
import Box from "@mui/material/Box";
import {CategoryDetails} from "@/types";
import ContentTitles from "@/ui/content-titles/content-titles";
import ServiceTile from "@/ui/service-tile/service-tile";
import Button from "@mui/material/Button";

type ServiceCarouselTypes = {
    serviceCategory: CategoryDetails;
    title?: string;
    subTitle?: string;
    overline?: string;
}

const ServiceCarousel = ({serviceCategory, title, subTitle, overline}: ServiceCarouselTypes) => {

    const pattern = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='hexagons' fill='%23ffffff' fill-opacity='0.4' fill-rule='nonzero'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";

    return (
        <div
            style={{
                backgroundColor: '#f4f4f4',
                backgroundImage: `url("${pattern}")`,
                backgroundSize: 'cover'
            }}
            className="text-white overflow-hidden py-12"
        >
            {(title || subTitle) &&
                <Box pb={3}>
                    <ContentTitles
                        overline={overline}
                        title={title}
                        subTitle={subTitle}
                        titleVariant='h2'
                        titleComponent='h3'
                        subTitleVariant='body1'
                        subTitleComponent='h6'
                    /></Box>}
            <div className="w-full max-w-6xl mx-auto pb-10">
                <Swiper
                    loop={true}
                    dir="rtl"
                    modules={[Autoplay]}
                    speed={6000}
                    autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                    allowTouchMove={true}
                    className="swiper-top"
                    breakpoints={{
                        0: {
                            slidesPerView: 1.5,
                            spaceBetween: 10,
                        },
                        550: {
                            slidesPerView: 2.2,
                            spaceBetween: 15,
                        },
                        670: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                        },
                    }}
                >

                    {serviceCategory?.subCategories.map((s, i) => (
                        <SwiperSlide key={`${s.id}-${i}`}>
                            {/*<div>*/}
                            <ServiceTile
                                service={s}
                                height='200px'
                                width='100%'
                                isBackground={true}
                            />
                            {/*</div>*/}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className='flex justify-center'>
                <Button
                    variant='outlined'
                    className='slide-up'
                    // sx={(theme: Theme) => buttonMainStyle(theme)}
                    href={`/${serviceCategory.categoryType}/${serviceCategory.slug}`}
                >
                    View more
                </Button>
            </div>

        </div>
    );
}

export default ServiceCarousel;
